function getCurrencySign(country) {
    if (!country) return "";
    const countryUpper = country.toUpperCase();
    switch (countryUpper) {
        case "UK":
            return "£";
        case "US":
            return "$";
        case "EU":
            return "€";
        case "GHANA":
            return "GH₵";
        case "NIGERIA":
            return "₦";
        default:
            return "";
}

}

function formatAmount(amount) {
    if (amount === null || amount === undefined) return "";
    return new Intl.NumberFormat('en-US', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(amount);
}

function formatDate(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return new Intl.DateTimeFormat("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  }).format(d);
}

function buildDateText(startISO, endISO) {
  const start = formatDate(startISO);
  const end = formatDate(endISO);

  if (!start && !end) return "Date TBA";
  if (start && !end) return start;
  if (!start && end) return end;

  const s = new Date(startISO);
  const e = new Date(endISO);

  // If both are valid dates
  if (!Number.isNaN(s.getTime()) && !Number.isNaN(e.getTime())) {
    // If same calendar date, return only one
    const sameDay =
      s.getFullYear() === e.getFullYear() &&
      s.getMonth() === e.getMonth() &&
      s.getDate() === e.getDate();

    if (sameDay) return start;

    // If end is earlier than start (bad data), just show start
    if (e < s) return start;
  }

  // Fallback (string compare or formatted compare)
  if (startISO === endISO || start === end) return start;

  return `${start} - ${end}`;
}


module.exports = {
    getCurrencySign,
    formatAmount,
    buildDateText
};

